import type { CustomerDetails, CustomerForm } from '@ts-customers/interfaces'
import type { CustomerStore } from './interfaces'

const toForm = (details: CustomerDetails): CustomerForm => ({
  first_name: details.first_name,
  last_name: details.last_name ?? '',
  email: details.email ?? '',
  phone: details.phone ?? '',
  timezone: details.timezone ?? '',
  notes: details.notes ?? '',
  pricing_model: details.pricing_model ?? '',
  payment_provider: details.payment_provider ?? '',
  screen_recording: details.screen_recording,
  ai_summarize: details.ai_summarize,
  contact_data: {
    contact_channels: [...(details.contact_data?.contact_channels ?? [])],
    notification_channels: [...(details.contact_data?.notification_channels ?? [])],
  },
})

export const actions = {
  setCustomer (this: CustomerStore, payload: CustomerStore['customer']): void {
    this.customer = payload
  },
  resetCustomer (this: CustomerStore): void {
    this.customer = null
  },
  /** Also reseeds the form, so a refetch after a save or a CRM pull shows the stored values. */
  setDetails (this: CustomerStore, payload: CustomerStore['details']): void {
    this.details = payload
    this.form = payload ? toForm(payload) : null
  },
  resetDetails (this: CustomerStore): void {
    this.details = null
    this.form = null
  },
  setFormField<K extends keyof CustomerForm> (this: CustomerStore, key: K, value: CustomerForm[K]): void {
    if (!this.form) return

    this.form[key] = value
  },
  trackProcessing (this: CustomerStore, isStarted: boolean): void {
    this.processing = Math.max(0, this.processing + (isStarted ? 1 : -1))
  },
  setModalDelete (this: CustomerStore, payload: CustomerStore['modalDelete']): void {
    this.modalDelete = payload
  },
  setModalKidCreate (this: CustomerStore, payload: CustomerStore['modalKidCreate']): void {
    this.modalKidCreate = payload
  },
}
